
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAgeGroupOptions } from "@/hooks/useAgeGroupOptions";

interface SettingsSectionProps {
  formData: {
    difficulty?: "easy" | "medium" | "hard";
    age_group?: string;
    icon?: string;
    status?: "draft" | "published" | "archived";
  };
  onFieldChange: (field: string, value: string) => void;
}

export const SettingsSection = ({ formData, onFieldChange }: SettingsSectionProps) => {
  const { ageGroups } = useAgeGroupOptions();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Settings</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="difficulty">Difficulty</Label>
          <Select 
            value={formData.difficulty || 'easy'} 
            onValueChange={(value: "easy" | "medium" | "hard") => onFieldChange('difficulty', value)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="easy">Easy</SelectItem>
              <SelectItem value="medium">Medium</SelectItem>
              <SelectItem value="hard">Hard</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="age_group">Age Group</Label>
          <Select 
            value={formData.age_group || ''} 
            onValueChange={(value) => onFieldChange('age_group', value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select an age group" />
            </SelectTrigger>
            <SelectContent>
              {ageGroups.map((ageGroup) => (
                <SelectItem key={ageGroup.id} value={ageGroup.name}>
                  {ageGroup.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="icon">Icon</Label>
          <Input
            id="icon"
            value={formData.icon}
            onChange={(e) => onFieldChange('icon', e.target.value)}
            placeholder="Icon name or URL"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="status">Status</Label>
          <Select 
            value={formData.status} 
            onValueChange={(value: "draft" | "published" | "archived") => onFieldChange('status', value)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="draft">Draft</SelectItem>
              <SelectItem value="published">Published</SelectItem>
              <SelectItem value="archived">Archived</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
